import { flatten } from 'lodash/fp'
import { createField, createSectionCreator } from 'e-submission/domain/data-model/form/utils'

export const ConsentDCASection = createSectionCreator((app, id, section) => {
  return flatten([
    createField(`DCA.consent`, [
      {
        id: `DCA.consent`,
        c: 'ConsentDCAPage',
      },
    ]),
  ])
})
